export const nav = {
  en: {
    projects: 'Projects',
    experience: 'Experience',
    skills: 'Skills',
    about: 'About',
    education: 'Education',
    contact: 'Contact'
  },
  es: {
    projects: 'Proyectos',
    experience: 'Experiencia',
    skills: 'Habilidades',
    about: 'Sobre mí',
    education: 'Educación',
    contact: 'Contacto'
  }
}
export const ui = {
  en: {
    eyebrow: 'BUILDING SOLUTIONS THAT MATTER',
    work: 'View my work',
    cv: 'Download CV',
    technologies: 'TRUSTED TECHNOLOGIES',
    featured: 'FEATURED PROJECTS',
    featuredSub:
      'Selected products, platforms and solutions developed throughout my career.',
    viewProject: 'View project',
    experience: 'PROFESSIONAL EXPERIENCE',
    education: 'EDUCATION',
    skills: 'TECHNICAL SKILLS',
    about: 'ABOUT ME',
    contact: 'LET’S BUILD SOMETHING GREAT',
    contactText:
      'For professional opportunities, software projects or technical collaboration, feel free to get in touch.',
    talk: "Let's talk",
    fullExperience: 'View full experience',
    languages: 'LANGUAGES',
    interests: 'PROFESSIONAL INTERESTS',
    download: 'Download CV',
    remote: 'Remote ready',
    learner: 'Continuous learner',
    problem: 'Problem solver',
    opportunities: 'Open to opportunities'
  },
  es: {
    eyebrow: 'CONSTRUYENDO SOLUCIONES QUE IMPORTAN',
    work: 'Ver mi trabajo',
    cv: 'Descargar CV',
    technologies: 'TECNOLOGÍAS PRINCIPALES',
    featured: 'PROYECTOS DESTACADOS',
    featuredSub:
      'Selección de productos, plataformas y soluciones desarrolladas durante mi carrera.',
    viewProject: 'Ver proyecto',
    experience: 'EXPERIENCIA PROFESIONAL',
    education: 'EDUCACIÓN',
    skills: 'HABILIDADES TÉCNICAS',
    about: 'SOBRE MÍ',
    contact: 'CONSTRUYAMOS ALGO GENIAL',
    contactText:
      'Para oportunidades profesionales, proyectos de software o colaboración técnica, no dudes en contactarme.',
    talk: 'Hablemos',
    fullExperience: 'Ver experiencia completa',
    languages: 'IDIOMAS',
    interests: 'INTERESES PROFESIONALES',
    download: 'Descargar CV',
    remote: 'Preparado para remoto',
    learner: 'Aprendiz continuo',
    problem: 'Resolutivo',
    opportunities: 'Abierto a oportunidades'
  }
}
export const technologies = [
  'React',
  'Angular',
  'JavaScript',
  'PHP',
  'Symfony',
  'CodeIgniter',
  'Flutter',
  'PostgreSQL',
  'MySQL',
  'SQL Server',
  '.NET',
  'Git'
]
export const projects = [
  {
    id: 'reserva',
    title: 'Reserva Ya',
    category: { en: 'SaaS · Web · Mobile', es: 'SaaS · Web · Móvil' },
    description: {
      en: 'Reservation management platform for businesses to manage establishments, services, schedules, users, reservations, catalogs and reports.',
      es: 'Plataforma SaaS de gestión de reservas para administrar establecimientos, servicios, horarios, usuarios, reservas, catálogos y reportes.'
    },
    stack: 'React · Flutter · CodeIgniter 4 · PostgreSQL',
    visual: 'reservation',
    url: 'https://www.sigmatecteam.com/#portfolio'
  },
  {
    id: 'elc',
    title: 'Estée Lauder E-Commerce',
    category: { en: 'E-Commerce · LATAM', es: 'E-Commerce · LATAM' },
    description: {
      en: 'Technical development and maintenance of transactional e-commerce platforms for Estée Lauder Companies across Mexico, Chile and Brazil.',
      es: 'Desarrollo y mantenimiento técnico de plataformas e-commerce transaccionales de Estée Lauder Companies para México, Chile y Brasil.'
    },
    stack: 'JavaScript · jQuery · PHP · Perl · E-Commerce',
    visual: 'beauty',
    url: 'https://www.maccosmetics.com.mx/'
  },
  {
    id: 'cnel',
    title: 'CNEL Work Management',
    category: { en: 'Enterprise · React', es: 'Empresarial · React' },
    description: {
      en: 'Operations tracking and work management system for utility tasks, improving reporting accuracy and field workflow efficiency.',
      es: 'Sistema de gestión y seguimiento de operaciones para tareas de servicios públicos, mejorando la precisión de reportes y los flujos de trabajo de campo.'
    },
    stack: 'React · Enterprise Systems',
    visual: 'dashboard',
    url: 'https://www.cnelep.gob.ec/'
  },
  {
    id: 'sngr',
    title: 'SNGR Risk Management',
    category: { en: 'Government · Symfony', es: 'Gobierno · Symfony' },
    description: {
      en: 'Nationwide risk monitoring system with real-time data processing and strategic visualization for state-level decision making.',
      es: 'Sistema nacional de monitoreo de riesgos con procesamiento de datos en tiempo real y visualización estratégica para la toma de decisiones.'
    },
    stack: 'Symfony · PHP · Data Visualization',
    visual: 'risk',
    url: 'https://sagrc.gestionderiesgos.gob.ec/'
  },
  {
    id: 'notify',
    title: 'Mass Notification System',
    category: { en: 'Real-Time · React', es: 'Tiempo real · React' },
    description: {
      en: 'Instantaneous real-time message broadcasting platform designed to distribute notifications at scale.',
      es: 'Plataforma de difusión de mensajes en tiempo real diseñada para distribuir notificaciones a gran escala.'
    },
    stack: 'React · Real-Time Messaging',
    visual: 'notify',
    url: 'https://www.goitsa.me/'
  },
  {
    id: 'doxi',
    title: 'Doxi Regional Microsites',
    category: { en: 'Frontend · LATAM', es: 'Frontend · LATAM' },
    description: {
      en: 'Frontend components for regional consumer-brand microsites, including Pizza Hut Bolivia and Café Martínez Argentina.',
      es: 'Componentes Frontend para micrositios regionales de marcas de consumo, incluyendo Pizza Hut Bolivia y Café Martínez Argentina.'
    },
    stack: 'Angular · HTML · CSS',
    visual: 'microsite',
    urls: ['https://pizzahut.com.bo/', 'https://www.cafemartinez.com/']
  }
]
export const experience = [
  {
    company: 'EXPANDYA · Estée Lauder Companies',
    period: '2021 — 2026',
    periodEs: '2021 — 2026',
    role: 'Full-Stack Developer',
    roleEs: 'Desarrollador Full-Stack',
    location: 'NY / Remote',
    bullets: {
      en: [
        'Lead technical maintenance and development of Front-End and Back-End functionalities for Estée Lauder Companies e-commerce platforms within the LATAM team.',
        'Support high-traffic transactional sites across Mexico, Chile and Brazil.',
        'Architect and implement critical checkout features and payment methods for MAC Cosmetics Mexico, optimizing regional conversion.',
        'Develop and deploy automated server-side scripts for business reporting and metrics analytics.'
      ],
      es: [
        'Liderazgo técnico en mantenimiento y desarrollo de funcionalidades Front-End y Back-End para plataformas e-commerce de Estée Lauder Companies en el equipo LATAM.',
        'Soporte de sitios transaccionales de alto tráfico en México, Chile y Brasil.',
        'Arquitectura e implementación de funcionalidades críticas de checkout y métodos de pago para MAC Cosmetics México, optimizando la conversión regional.',
        'Desarrollo y despliegue de scripts server-side automatizados para reportes de negocio y métricas.'
      ]
    }
  },
  {
    company: 'Freelance / GOIT S.A.',
    period: 'Various periods',
    periodEs: 'Varios períodos',
    role: 'Consultant & Software Engineer',
    roleEs: 'Consultor e Ingeniero de Software',
    location: 'Ecuador',
    bullets: {
      en: [
        'CNEL: designed and implemented a React work management system for utility operations, reporting and field workflows.',
        'SNGR: collaborated on a nationwide risk monitoring system using Symfony, real-time data processing and strategic visualization.',
        'Mass Notification System: engineered and scaled an instantaneous real-time message broadcasting platform using React.',
        'Doxi: developed Angular and HTML Front-End components for Pizza Hut Bolivia and Café Martínez Argentina.'
      ],
      es: [
        'CNEL: diseño e implementación de un sistema React para gestión de trabajo, operaciones, reportes y flujos de campo.',
        'SNGR: colaboración en un sistema nacional de monitoreo de riesgos con Symfony, procesamiento en tiempo real y visualización estratégica.',
        'Sistema de Notificaciones Masivas: desarrollo y escalamiento de una plataforma de difusión instantánea en tiempo real con React.',
        'Doxi: desarrollo de componentes Front-End con Angular y HTML para Pizza Hut Bolivia y Café Martínez Argentina.'
      ]
    }
  },
  {
    company: 'ARCSA',
    period: '2017 — 2021',
    periodEs: '2017 — 2021',
    role: 'Security and Applications Analyst 2',
    roleEs: 'Analista de Seguridad y Aplicaciones 2',
    location: 'Guayaquil, Ecuador',
    bullets: {
      en: [
        'Led migration of the core institutional web platform to React.',
        'Developed internal modules for payroll distribution, reporting databases and consulting agency lookups using PHP, PostgreSQL and MySQL.',
        'Monitored, audited and maintained high availability for national Operating Permits portal servers, providing tier-2 technical support.'
      ],
      es: [
        'Lideré la migración de la plataforma web institucional principal a React.',
        'Desarrollé módulos internos para distribución de nómina, bases de datos de reportes y consultas de agencias con PHP, PostgreSQL y MySQL.',
        'Monitoreé, audité y mantuve alta disponibilidad de servidores del portal nacional de Permisos de Funcionamiento, brindando soporte técnico de segundo nivel.'
      ]
    }
  },
  {
    company: 'GURUSOFT',
    period: '2015 — 2017',
    periodEs: '2015 — 2017',
    role: 'Project Lead Engineer',
    roleEs: 'Ingeniero Líder de Proyectos',
    location: 'Guayaquil, Ecuador',
    bullets: {
      en: [
        'Led technical development squads building web applications for Human Resources, Corporate Management and Accounting ERP systems using .NET and SQL Server.'
      ],
      es: [
        'Lideré equipos técnicos para desarrollar aplicaciones web de Recursos Humanos, Gestión Corporativa y sistemas ERP contables con .NET y SQL Server.'
      ]
    }
  },
  {
    company: 'SOLINTEGRA',
    period: '2014 — 2015',
    periodEs: '2014 — 2015',
    role: 'Developer',
    roleEs: 'Desarrollador',
    location: 'Guayaquil, Ecuador',
    bullets: {
      en: [
        'Built scalable enterprise functionality and integrated new ERP features using .NET and advanced SQL Server scripting.'
      ],
      es: [
        'Desarrollé funcionalidades empresariales escalables e integré nuevas funcionalidades ERP usando .NET y scripting avanzado de SQL Server.'
      ]
    }
  },
  {
    company: 'Early Professional History',
    period: '2006 — 2013',
    periodEs: '2006 — 2013',
    role: 'Technical & Support Roles',
    roleEs: 'Roles técnicos y de soporte',
    location:
      'Kallpa Crossfit · Cía General de Construcciones · Grupo Gregor S.A.',
    bullets: {
      en: [
        'Foundational roles covering hardware maintenance, system configuration, user support and accounting assistance.'
      ],
      es: [
        'Roles iniciales relacionados con mantenimiento de hardware, configuración de sistemas, soporte a usuarios y asistencia contable.'
      ]
    }
  }
]
export const skills = {
  en: [
    [
      'Frontend',
      [
        'JavaScript',
        'React',
        'Angular',
        'jQuery',
        'AJAX',
        'HTML5',
        'CSS3',
        'SCSS',
        'Bootstrap'
      ]
    ],
    ['Backend & Frameworks', ['PHP', 'Symfony', 'CodeIgniter', '.NET', 'Perl']],
    ['Mobile', ['Flutter']],
    ['Databases', ['SQL Server', 'MySQL', 'PostgreSQL']],
    [
      'Methodologies & Tools',
      ['Scrum / Agile', 'Git', 'Server Management', 'Infrastructure Monitoring']
    ],
    [
      'Languages',
      ['Spanish — Native', 'English — Professional Working Proficiency']
    ]
  ],
  es: [
    [
      'Frontend',
      [
        'JavaScript',
        'React',
        'Angular',
        'jQuery',
        'AJAX',
        'HTML5',
        'CSS3',
        'SCSS',
        'Bootstrap'
      ]
    ],
    ['Backend y Frameworks', ['PHP', 'Symfony', 'CodeIgniter', '.NET', 'Perl']],
    ['Móvil', ['Flutter']],
    ['Bases de datos', ['SQL Server', 'MySQL', 'PostgreSQL']],
    [
      'Metodologías y herramientas',
      [
        'Scrum / Agile',
        'Git',
        'Administración de servidores',
        'Monitoreo de infraestructura'
      ]
    ],
    [
      'Idiomas',
      ['Español — Nativo', 'Inglés — Competencia profesional de trabajo']
    ]
  ]
}
export const education = [
  {
    school: 'Universidad de Guayaquil',
    period: '2009 — 2016',
    degree: { en: 'Systems Engineer', es: 'Ingeniero en Sistemas' },
    detail: {
      en: 'Degree completed in Ecuador.',
      es: 'Título universitario en Ecuador.'
    }
  },
  {
    school: 'Teodoro Alvarado Oleas',
    period: '2000 — 2007',
    degree: {
      en: 'Technical Baccalaureate in IT and Business Administration',
      es: 'Bachillerato Técnico en Informática y Administración de Empresas'
    },
    detail: {
      en: 'Technical secondary education.',
      es: 'Formación secundaria técnica.'
    }
  }
]
export const professionalInterests = {
  en: [
    'Modern development architectures',
    'Software engineering innovation',
    'Clean code practices',
    'Agile environments',
    'Collaborative technology cultures',
    'Healthy work-life balance'
  ],
  es: [
    'Arquitecturas modernas de desarrollo',
    'Innovación en ingeniería de software',
    'Buenas prácticas de código limpio',
    'Entornos Agile',
    'Culturas tecnológicas colaborativas',
    'Equilibrio saludable entre trabajo y vida personal'
  ]
}
